var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteListIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8333 14.1667V13.3333C15.8333 12.4129 16.5795 11.6667 17.5 11.6667H22.5C23.4205 11.6667 24.1667 12.4129 24.1667 13.3333V14.1667H26.6667C27.1269 14.1667 27.5 14.5398 27.5 15C27.5 15.4602 27.1269 15.8333 26.6667 15.8333H25.8333V25C25.8333 26.3807 24.714 27.5 23.3333 27.5H16.6667C15.286 27.5 14.1667 26.3807 14.1667 25V15.8333H13.3333C12.8731 15.8333 12.5 15.4602 12.5 15C12.5 14.5398 12.8731 14.1667 13.3333 14.1667H15.8333ZM17.5 13.3333H22.5V14.1667H17.5V13.3333ZM15.8333 15.8333H24.1667V25C24.1667 25.4602 23.7936 25.8333 23.3333 25.8333H16.6667C16.2064 25.8333 15.8333 25.4602 15.8333 25V15.8333Z",
    fill: "#1A3D82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 17.5H20.8333V24.1667H22.5V17.5Z",
    fill: "#1A3D82"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 17.5H17.5V24.1667H19.1667V17.5Z",
    fill: "#1A3D82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteListIcon);
export default __webpack_public_path__ + "static/media/deleteListIcon.e9e0d6c432b9f8e00018c958a5484317.svg";
export { ForwardRef as ReactComponent };